/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { GetPreferencesQueryResponse } from '../../types/GetPreferences'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getPreferences } from '../../clients/getPreferences'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getPreferencesQueryKey = () =>
  [{ url: '/api/v1/preferences/' }] as const

export type GetPreferencesQueryKey = ReturnType<typeof getPreferencesQueryKey>

export function getPreferencesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getPreferencesQueryKey()
  return queryOptions<
    GetPreferencesQueryResponse,
    ResponseErrorConfig<Error>,
    GetPreferencesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getPreferences({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary Get tooltips, feature flags, company-type prefixes, misc settings, reporting unit
 * {@link /api/v1/preferences/}
 */
export function useGetPreferences<
  TData = GetPreferencesQueryResponse,
  TQueryData = GetPreferencesQueryResponse,
  TQueryKey extends QueryKey = GetPreferencesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetPreferencesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getPreferencesQueryKey()

  const query = useQuery(
    {
      ...getPreferencesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
